// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formikSelectSign {
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 15px 8px !important;
  background-repeat: no-repeat;
  background-size: 4%;
  background-position: top 50% right 6%;
}

.css-i4bv87-MuiSvgIcon-root {
    -webkit-user-select: none;
    user-select: none;
    width: 1em;
    height: 1em;
    display: inline-block;
    fill: currentColor;
    flex-shrink: 0;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    font-size: 1.5rem;
}

.login-dancer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  width: 421px;
  height: auto;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.login-dancer .MuiSvgIcon-root {
  margin-left: -8px !important;
}

.css-sjumqa-MuiButtonBase-root-MuiButton-root:hover {
  border: 0px solid !important;
  background: #fbb040;
  color: #ffffff;
}

.makeVisible {
  background-color: black;
}
@media only screen and (min-width: 0px) and (max-width: 700px) {
  .recvrNext {
    font-size: 16px !important;
  }
}
@media only screen and (min-width: 760px) and (max-width: 1200px) {
  .recvrNext {
    font-size: 18px !important;
  }
}

.makeInvisible {
  opacity: 0.3;
}

.plusIconbtn:hover #plusICon {
  visibility: hidden !important;
  width: 0px;
  transition-property: width;
  transition-duration: 0.3s;
  margin: auto;
}

.plusIconbtn .MuiSvgIcon-root {
  margin: 0 5px 0 0;
}
.login-dancer .MuiSvgIcon-root {
  margin-left: 0px !important;
}
.add_dance_btn :hover {
  cursor: auto !important;
}

.css-sjumqa-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: white !important;
}

.css-sjumqa-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 11px;
  gap: 8px;
  width: 192px;
  height: 42px;
  background: #68ad3f !important;
  color: white !important;
  opacity: 0.3 !important;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.css-sjumqa-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: white !important;
  opacity: 0.5 !important;
}

#selectField select :option {
  background-color: black !important;
  border-radius: 2px solid black !important;
}

.AddDancernme {
  font-size: 16px;
}

.formikSelect option {
  color: black;
}
#completeRegistrationbtn{
  padding: 7px 8px;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  /* Safari and Chrome */
  .formikSelect option {
    color: black;
  }

  .deleteIcon {
    color: black;
  }
}

.helpImageDiv {
  position: fixed;
  bottom: 3vw;
  right: 3vw;
}

.formikSelect {
  height: 42px;
}

.allDancers {
  width: 80%;
  margin: 8px;
  border-radius: 8px;
  box-shadow: 8px 8px 34px rgb(0 0 0 / 5%);
}
.login-dancer .css-46bh2p-MuiCardContent-root {
  padding: 15px 16px;
}
.title-signup {
  color: #323232;
}

.email-form {
  width: 300px;
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 500;
  margin-left: 5px;
}

input[type="checkbox"]::before {
  height: 20px;
  width: 20px;
  padding: 10px 0px 10px 0px;
}

input [type="select"]::after {
  border-radius: "45px";
}

.forgot-password {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #68ad3f;
  font-weight: 500;
}

.sign-up-btn {
  cursor: pointer;
  color: #68ad3f;
  font-weight: 500;
}

/* <---------------------------- CSS for SignUp Page -------------------------------------> */
.signupmain {
  width: 530px;
  height: auto;
  padding: 40px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: auto;
}

.signUpTitle {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 120%;
  color: #323232;
}

.signUpForm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sign-up-form input {
  width: 100%;
}

.subtitle-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.role-name {
  cursor: pointer;
  display: flex;
  color: #424242;
  font-size: 14px;
  font-weight: 400;
  width: 190px;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 15px 28px rgb(0 0 0 / 5%);
  border-radius: 4px;
  align-items: center;
  padding: 10px;
  margin: 15px;
}

.role-name:hover {
  transform: translateY(-10px);
  transition: transform 500ms;
  box-shadow: 0px 12px 27px rgba(0, 0, 0, 0.15);
}

.role {
  margin: 0px 0px 0px 10px;
}

/* <---------------------------- CSS for SignUp Page -------------------------------------> */

/* <---------------------------- media query for mobile devices -------------------------------------> */
@media only screen and (min-width: 0px) and (max-width: 330px) {
  .form {
    width: 250px;
  }
  .allDancers {
    width: 100%;
  }
}

/* <---------------------------- media query for mobile devices -------------------------------------> */
@media only screen and (min-width: 331px) and (max-width: 560px) {
  .form {
    width: 300px;
  }

  .forgot-password {
    height: 200px;
  }
  .allDancers {
    width: 100%;
  }
}

.sign-up-forgot-pwd-div {
  color: #060705;
  font-size: 14px;
}

.sign-up-forgot-pwd-btn {
  cursor: pointer;
  color: #323232;
}

.email-password {
  padding: 10px;
}

.title-signin {
  color: #323232;
  font-weight: 500;
  font-size: 22px;
}

.email-form-signIn {
  width: 530px;
  height: auto;
  padding: 40px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.login-form-signIn {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* <---------------------------- CSS for signIn Page -------------------------------------> */

/* <---------------------------- CSS for ResetPassword Page -------------------------------------> */
.email-form-reset {
  width: auto;
  height: auto;
  padding: 40px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

/* <---------------------------- CSS for ResetPassword Page -------------------------------------> */
.reset-pwd-login-button {
  background: none;
  border: none;
  cursor: pointer;
}

.email-password-reset {
  width: "450px";
  height: "39px";
}

/* <---------------------------- media query for mobile devices -------------------------------------> */
@media only screen and (min-width: 0px) and (max-width: 319px) {
  .form {
    width: 250px;
  }

  /*--------------signIn--------------*/
  .email-form-signIn {
    width: 300px;
  }

  .sign-up-forgot-pwd-div {
    color: #060705;
    font-size: 10px;
  }

  /*--------------signIn--------------*/
}

/* <---------------------------- media query for mobile devices -------------------------------------> */
@media only screen and (min-width: 320px) and (max-width: 560px) {
  .form {
    width: 300px;
  }
 
  .forgot-password {
    height: 200px;
  }
  .login-dancer {
    width: 300px;
  }

  /*--------------signIn--------------*/
  .email-form-signIn {
    position: relative;
    width: 300px;
    height: auto;
    z-index: 99;
  }

  .sign-up-forgot-pwd-div {
    color: #060705;
    font-size: 10px;
  }

  /*--------------signIn--------------*/
  /*--------------resetPassword--------------*/
  .title-resetPwd {
    font-size: 18px;
  }

  .subtitle-resetPwd {
    font-size: small;
  }

  /*--------------resetPassword--------------*/
}

.css-m7ed81.Mui-disabled {
  background: #68ad3f !important;
  color: white !important;
  opacity: 0.3 !important;
}

.change-password-btn .Mui-disabled {
  color: white !important;
  opacity: 0.3 !important;
}

.css-199mpmr {
  display: inline-flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  outline: 0px;
  border: 0px;
  margin: 0px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  text-transform: none;
  font-family: Rubik;
  font-weight: 500;
  line-height: 1.75;
  min-width: 64px;
  padding: 6px 25px;
  border-radius: 4px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: rgb(104, 173, 63);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
  color: white;
  height: 39px;
  font-size: 16px;
  justify-content: center;
}

.addDAncers {
  width: 300px;
  height: 100px;
  color: black;
  transition-property: width;
  transition-duration: 1s;
}

.addDAncers:hover {
  width: 100px;
}

@media only screen and (min-width: 600px) and (max-width: 1200px) {
  .login-dancer {
    width: 500px;
  }
}

@media only screen and (min-width: 1900px) and (max-width: 1930px) {
  .login-dancer .MuiTypography-root {
    margin: 0 !important;
    font-family: Rubik !important;
    font-weight: 400 !important;

    line-height: 1.5 !important;
    margin-bottom: 0.35em !important;
    max-width: 100% !important;
  }
}
@media screen and (min-width: 1200px) {
  .signUpAlr {
    /* margin-bottom: 3rem !important; */
    margin-top: 3rem !important;
  }
}
@media screen and (min-width: 1900px) {
  .login-dancer .MuiSvgIcon-root {
    margin-left: -6px !important;
  }
  #ADDdANCER:hover{
    margin-left: 5px !important;
  }
}
@media screen and (max-width:700px) {
  .formikSelectSign {
    -webkit-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 12px 7px !important;
    background-repeat: no-repeat;
    background-size: 4%;
    background-position: top 50% right 8%;
}
.helpImageDiv img{
  height: 46px;
}
}`, "",{"version":3,"sources":["webpack://./src/Parent/Auth/style.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yDAAqD;EACrD,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;IACI,yBAAyB;IAGzB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAGlB,cAAc;IAEd,uDAAuD;IACvD,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,6FAA6F;AAC7F;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6FAA6F;;AAE7F,wGAAwG;AACxG;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA,wGAAwG;AACxG;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6FAA6F;;AAE7F,oGAAoG;AACpG;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,oGAAoG;AACpG;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,wGAAwG;AACxG;EACE;IACE,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,qCAAqC;AACvC;;AAEA,wGAAwG;AACxG;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;;EAEA,qCAAqC;EACrC;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,qCAAqC;EACrC,4CAA4C;EAC5C;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EAEpB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB;;;gDAG8C;EAC9C,mCAAmC;EACnC;4EAC0E;EAC1E,YAAY;EACZ,YAAY;EACZ,eAAe;EAEf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;;IAE3B,2BAA2B;IAC3B,gCAAgC;IAChC,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,oCAAoC;IACpC,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,wBAAwB;IACxB,yDAA6Z;IAC7Z,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB;IACnB,qCAAqC;AACzC;AACA;EACE,YAAY;AACd;AACA","sourcesContent":[".formikSelectSign {\n  -webkit-appearance: none;\n  background-image: url(\"../../Assets/selectArrow.png\");\n  background-size: 15px 8px !important;\n  background-repeat: no-repeat;\n  background-size: 4%;\n  background-position: top 50% right 6%;\n}\n\n.css-i4bv87-MuiSvgIcon-root {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    width: 1em;\n    height: 1em;\n    display: inline-block;\n    fill: currentColor;\n    -webkit-flex-shrink: 0;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    -webkit-transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    font-size: 1.5rem;\n}\n\n.login-dancer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  width: 421px;\n  height: auto;\n  margin: auto;\n  background: #ffffff;\n  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.login-dancer .MuiSvgIcon-root {\n  margin-left: -8px !important;\n}\n\n.css-sjumqa-MuiButtonBase-root-MuiButton-root:hover {\n  border: 0px solid !important;\n  background: #fbb040;\n  color: #ffffff;\n}\n\n.makeVisible {\n  background-color: black;\n}\n@media only screen and (min-width: 0px) and (max-width: 700px) {\n  .recvrNext {\n    font-size: 16px !important;\n  }\n}\n@media only screen and (min-width: 760px) and (max-width: 1200px) {\n  .recvrNext {\n    font-size: 18px !important;\n  }\n}\n\n.makeInvisible {\n  opacity: 0.3;\n}\n\n.plusIconbtn:hover #plusICon {\n  visibility: hidden !important;\n  width: 0px;\n  transition-property: width;\n  transition-duration: 0.3s;\n  margin: auto;\n}\n\n.plusIconbtn .MuiSvgIcon-root {\n  margin: 0 5px 0 0;\n}\n.login-dancer .MuiSvgIcon-root {\n  margin-left: 0px !important;\n}\n.add_dance_btn :hover {\n  cursor: auto !important;\n}\n\n.css-sjumqa-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: white !important;\n}\n\n.css-sjumqa-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 9px 11px;\n  gap: 8px;\n  width: 192px;\n  height: 42px;\n  background: #68ad3f !important;\n  color: white !important;\n  opacity: 0.3 !important;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.css-sjumqa-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: white !important;\n  opacity: 0.5 !important;\n}\n\n#selectField select :option {\n  background-color: black !important;\n  border-radius: 2px solid black !important;\n}\n\n.AddDancernme {\n  font-size: 16px;\n}\n\n.formikSelect option {\n  color: black;\n}\n#completeRegistrationbtn{\n  padding: 7px 8px;\n}\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  /* Safari and Chrome */\n  .formikSelect option {\n    color: black;\n  }\n\n  .deleteIcon {\n    color: black;\n  }\n}\n\n.helpImageDiv {\n  position: fixed;\n  bottom: 3vw;\n  right: 3vw;\n}\n\n.formikSelect {\n  height: 42px;\n}\n\n.allDancers {\n  width: 80%;\n  margin: 8px;\n  border-radius: 8px;\n  box-shadow: 8px 8px 34px rgb(0 0 0 / 5%);\n}\n.login-dancer .css-46bh2p-MuiCardContent-root {\n  padding: 15px 16px;\n}\n.title-signup {\n  color: #323232;\n}\n\n.email-form {\n  width: 300px;\n  display: flex;\n  flex-direction: column;\n}\n\nlabel {\n  font-weight: 500;\n  margin-left: 5px;\n}\n\ninput[type=\"checkbox\"]::before {\n  height: 20px;\n  width: 20px;\n  padding: 10px 0px 10px 0px;\n}\n\ninput [type=\"select\"]::after {\n  border-radius: \"45px\";\n}\n\n.forgot-password {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  color: #68ad3f;\n  font-weight: 500;\n}\n\n.sign-up-btn {\n  cursor: pointer;\n  color: #68ad3f;\n  font-weight: 500;\n}\n\n/* <---------------------------- CSS for SignUp Page -------------------------------------> */\n.signupmain {\n  width: 530px;\n  height: auto;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  margin: auto;\n}\n\n.signUpTitle {\n  font-family: \"Rubik\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 120%;\n  color: #323232;\n}\n\n.signUpForm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.sign-up-form input {\n  width: 100%;\n}\n\n.subtitle-text {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.role-name {\n  cursor: pointer;\n  display: flex;\n  color: #424242;\n  font-size: 14px;\n  font-weight: 400;\n  width: 190px;\n  height: 60px;\n  background: #ffffff;\n  box-shadow: 0px 15px 28px rgb(0 0 0 / 5%);\n  border-radius: 4px;\n  align-items: center;\n  padding: 10px;\n  margin: 15px;\n}\n\n.role-name:hover {\n  transform: translateY(-10px);\n  transition: transform 500ms;\n  box-shadow: 0px 12px 27px rgba(0, 0, 0, 0.15);\n}\n\n.role {\n  margin: 0px 0px 0px 10px;\n}\n\n/* <---------------------------- CSS for SignUp Page -------------------------------------> */\n\n/* <---------------------------- media query for mobile devices -------------------------------------> */\n@media only screen and (min-width: 0px) and (max-width: 330px) {\n  .form {\n    width: 250px;\n  }\n  .allDancers {\n    width: 100%;\n  }\n}\n\n/* <---------------------------- media query for mobile devices -------------------------------------> */\n@media only screen and (min-width: 331px) and (max-width: 560px) {\n  .form {\n    width: 300px;\n  }\n\n  .forgot-password {\n    height: 200px;\n  }\n  .allDancers {\n    width: 100%;\n  }\n}\n\n.sign-up-forgot-pwd-div {\n  color: #060705;\n  font-size: 14px;\n}\n\n.sign-up-forgot-pwd-btn {\n  cursor: pointer;\n  color: #323232;\n}\n\n.email-password {\n  padding: 10px;\n}\n\n.title-signin {\n  color: #323232;\n  font-weight: 500;\n  font-size: 22px;\n}\n\n.email-form-signIn {\n  width: 530px;\n  height: auto;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.login-form-signIn {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* <---------------------------- CSS for signIn Page -------------------------------------> */\n\n/* <---------------------------- CSS for ResetPassword Page -------------------------------------> */\n.email-form-reset {\n  width: auto;\n  height: auto;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n/* <---------------------------- CSS for ResetPassword Page -------------------------------------> */\n.reset-pwd-login-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.email-password-reset {\n  width: \"450px\";\n  height: \"39px\";\n}\n\n/* <---------------------------- media query for mobile devices -------------------------------------> */\n@media only screen and (min-width: 0px) and (max-width: 319px) {\n  .form {\n    width: 250px;\n  }\n\n  /*--------------signIn--------------*/\n  .email-form-signIn {\n    width: 300px;\n  }\n\n  .sign-up-forgot-pwd-div {\n    color: #060705;\n    font-size: 10px;\n  }\n\n  /*--------------signIn--------------*/\n}\n\n/* <---------------------------- media query for mobile devices -------------------------------------> */\n@media only screen and (min-width: 320px) and (max-width: 560px) {\n  .form {\n    width: 300px;\n  }\n \n  .forgot-password {\n    height: 200px;\n  }\n  .login-dancer {\n    width: 300px;\n  }\n\n  /*--------------signIn--------------*/\n  .email-form-signIn {\n    position: relative;\n    width: 300px;\n    height: auto;\n    z-index: 99;\n  }\n\n  .sign-up-forgot-pwd-div {\n    color: #060705;\n    font-size: 10px;\n  }\n\n  /*--------------signIn--------------*/\n  /*--------------resetPassword--------------*/\n  .title-resetPwd {\n    font-size: 18px;\n  }\n\n  .subtitle-resetPwd {\n    font-size: small;\n  }\n\n  /*--------------resetPassword--------------*/\n}\n\n.css-m7ed81.Mui-disabled {\n  background: #68ad3f !important;\n  color: white !important;\n  opacity: 0.3 !important;\n}\n\n.change-password-btn .Mui-disabled {\n  color: white !important;\n  opacity: 0.3 !important;\n}\n\n.css-199mpmr {\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  position: relative;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  outline: 0px;\n  border: 0px;\n  margin: 0px;\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  appearance: none;\n  text-decoration: none;\n  text-transform: none;\n  font-family: Rubik;\n  font-weight: 500;\n  line-height: 1.75;\n  min-width: 64px;\n  padding: 6px 25px;\n  border-radius: 4px;\n  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,\n    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  background-color: rgb(104, 173, 63);\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,\n    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;\n  color: white;\n  height: 39px;\n  font-size: 16px;\n  -webkit-box-pack: center;\n  justify-content: center;\n}\n\n.addDAncers {\n  width: 300px;\n  height: 100px;\n  color: black;\n  transition-property: width;\n  transition-duration: 1s;\n}\n\n.addDAncers:hover {\n  width: 100px;\n}\n\n@media only screen and (min-width: 600px) and (max-width: 1200px) {\n  .login-dancer {\n    width: 500px;\n  }\n}\n\n@media only screen and (min-width: 1900px) and (max-width: 1930px) {\n  .login-dancer .MuiTypography-root {\n    margin: 0 !important;\n    font-family: Rubik !important;\n    font-weight: 400 !important;\n\n    line-height: 1.5 !important;\n    margin-bottom: 0.35em !important;\n    max-width: 100% !important;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .signUpAlr {\n    /* margin-bottom: 3rem !important; */\n    margin-top: 3rem !important;\n  }\n}\n@media screen and (min-width: 1900px) {\n  .login-dancer .MuiSvgIcon-root {\n    margin-left: -6px !important;\n  }\n  #ADDdANCER:hover{\n    margin-left: 5px !important;\n  }\n}\n@media screen and (max-width:700px) {\n  .formikSelectSign {\n    -webkit-appearance: none;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==);\n    background-size: 12px 7px !important;\n    background-repeat: no-repeat;\n    background-size: 4%;\n    background-position: top 50% right 8%;\n}\n.helpImageDiv img{\n  height: 46px;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
